(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-header"]) return;
  try {
    
  (() => {
    const bindHoverMenus = () => {
      document.querySelectorAll('[data-rg-hover-menu]').forEach((menu) => {
        if (menu.dataset.rgHoverBound === 'true') return;
        menu.dataset.rgHoverBound = 'true';

        const summary = menu.querySelector('summary');
        let closeTimer;
        const desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');

        const openMenu = () => {
          window.clearTimeout(closeTimer);
          if (desktopHover.matches) menu.open = true;
        };

        const closeMenu = () => {
          if (!desktopHover.matches) return;
          closeTimer = window.setTimeout(() => {
            menu.open = false;
          }, 140);
        };

        menu.addEventListener('pointerenter', openMenu);
        menu.addEventListener('pointerleave', closeMenu);
        menu.addEventListener('focusin', () => window.clearTimeout(closeTimer));
        menu.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!menu.contains(document.activeElement)) menu.open = false;
          }, 0);
        });
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          menu.open = !menu.open;
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindHoverMenus, { once: true });
    } else {
      bindHoverMenus();
    }
    document.addEventListener('shopify:section:load', bindHoverMenus);
  })();

  } catch(e) { console.error(e); }
})();
})();
